<script lang="ts">
  import { replaceWithAnchors } from "../../../lib/conversation";

  export let s;
  export let overrideStyle;
  export let log;
</script>

<div class={s.chatBubbleAgent} style={overrideStyle} translate="no">
  {@html replaceWithAnchors(log.text.replace(/</g, "&lt;"))}
</div>
